import React from 'react';
import { ParkingCircle, Clock, Trophy, Dumbbell, HeartPulse, Coffee, ShowerHead, UserCheck } from 'lucide-react';
import { features } from '../data/mockData';

const iconMap = {
  'parking-circle': ParkingCircle,
  'clock': Clock,
  'trophy': Trophy,
  'dumbbell': Dumbbell,
  'heart-pulse': HeartPulse,
  'coffee': Coffee,
  'shower-head': ShowerHead,
  'user-check': UserCheck
};

const Features = () => {
  return (
    <section className="section-padding bg-wood">
      <div className="container mx-auto px-5 md:px-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="heading-2 mb-6 text-white">למה לבחור בנו?</h2>
          <p className="body-medium text-wood-light max-w-2xl mx-auto">
            חדר הכושר שלנו מציע חוויה מושלמת עם כל מה שצריך להצלחה
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => {
            const IconComponent = iconMap[feature.icon];
            return (
              <div 
                key={feature.id}
                className="feature-card"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="feature-icon-wrapper">
                  <IconComponent size={32} />
                </div>
                <h3 className="heading-5 text-white mb-2">
                  {feature.title}
                </h3>
                <p className="body-small text-wood-light">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Features;
